/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiARewindForwardIcon24Solid = forwardRef('MediaUiARewindForwardIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 13.76v4.465c0 1.377 1.552 2.183 2.678 1.39l8.44-5.938a2.05 2.05 0 0 0 0-3.354l-8.44-5.938C13.552 3.592 12 4.398 12 5.775v4.466L3.678 4.385C2.552 3.592 1 4.398 1 5.775v12.45c0 1.377 1.552 2.183 2.678 1.39L12 13.76Z" })));
});
